import { Link } from 'react-router-dom';
import logo from '../assets/footer-logo.png';

const festivalLinks = [
  { label: 'About', to: '/about' },
  { label: 'How It Works', to: '/#how' },
  { label: 'Prizes & Categories', to: '/#prizes' },
  { label: 'Submit Your Film', to: '/submit' },
  { label: 'Get Tickets', to: '/tickets' },
  { label: 'FAQ', to: '/faq' },
];

const partnerLinks = [
  { label: 'Become a Sponsor', to: '/sponsors' },
  { label: 'Affiliates', to: '/affiliates' },
];

const keyDates = [
  { label: 'Early Bird', date: 'Sep 18, 2026' },
  { label: 'Late Deadline', date: 'Nov 20, 2026' },
  { label: 'Festival', date: 'Jan 21–24, 2027' },
];

function SectionTitle({ children }) {
  return (
    <h4 className="font-mono text-[0.65rem] tracking-[0.2em] uppercase text-teal mb-4">
      {children}
    </h4>
  );
}

function FooterLink({ to, children, external }) {
  const className = "block text-[0.85rem] font-light mb-2 no-underline transition-colors hover:text-white"
  const style = { color: 'rgba(245,245,240,0.5)' };

  if (external) {
    return (
      <a href={to} target="_blank" rel="noopener noreferrer" className={className} style={style}>
        {children}
      </a>
    );
  }

  return (
    <Link to={to} className={className} style={style}>
      {children}
    </Link>
  );
}

export default function Footer() {
  return (
    <footer className="bg-dark2 p-12" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
      {/* Inner grid */}
      <div
        className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 pb-8"
        style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}
      >
        {/* Column 1 — Brand */}
        <div>
          <img src={logo} alt="Synema Interactive Film Festival" className="h-[19rem] w-auto mb-6" />
        </div>

        {/* Column 2 — Festival */}
        <div>
          <SectionTitle>Festival</SectionTitle>
          {festivalLinks.map((link) => (
            <FooterLink key={link.to} to={link.to}>
              {link.label}
            </FooterLink>
          ))}
        </div>

        {/* Column 3 — Partners + Contact */}
        <div>
          <SectionTitle>Partners</SectionTitle>
          {partnerLinks.map((link) => (
            <FooterLink key={link.to} to={link.to}>
              {link.label}
            </FooterLink>
          ))}
          <SectionTitle>Contact</SectionTitle>
          <FooterLink to="mailto:synemafest@gmail.com" external>
            synemafest@gmail.com
          </FooterLink>

          <SectionTitle>Key Dates</SectionTitle>
          {keyDates.map((item) => (
            <p
              key={item.label}
              className="text-[0.85rem] font-light mb-2"
              style={{ color: 'rgba(245,245,240,0.5)' }}
            >
              {item.label} — {item.date}
            </p>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="max-w-[1200px] mx-auto flex justify-between mt-6">
        <p className="text-[0.72rem]" style={{ color: 'rgba(245,245,240,0.5)' }}>
          © 2027 Synema Interactive Film Festival. Powered by{' '}
          <a
            href="https://mindi.tv"
            target="_blank"
            rel="noopener noreferrer"
            className="no-underline hover:underline"
            style={{ color: '#E8721C' }}
          >
            Mindi.TV
          </a>
        </p>
        <p className="text-[0.72rem]" style={{ color: 'rgba(245,245,240,0.5)' }}>
          synemafest.com
        </p>
      </div>
    </footer>
  );
}
